export function formatPhoneNumber(phone: string) {
    if (!phone) return '';
    const digits = phone.replace(/\D/g, ''); // usuń wszystko poza cyframi
    return digits.replace(/(\d{3})(\d{3})(\d{0,3})/, (_, a, b, c) =>
        [a, b, c].filter(Boolean).join('-')
    );
};
